import React from 'react';
import Icon from '@/components/ui/Icon';

interface StatusIndicatorProps {
  status: 'completed' | 'in_progress' | 'not_started';
}

const StatusIndicator = ({ status }: StatusIndicatorProps) => {
  if (status === 'not_started') return null;

  return (
    <Icon
      fill={status === 'completed' ? '#78962d' : '#ffca17'}
      icon="Circle"
      size={12}
    />
  );
};

export default StatusIndicator;
